const proxy = "https://proxy-ewozx.herokuapp.com/";
const PRU = "shasta.";// shasta1. para inhabilitar red de pruebas

const WS = "T9yD14Nj9j7xAB4dbGeiX9h8unkKHxuWwb";//T9yD14Nj9j7xAB4dbGeiX9h8unkKHxuWwb recibe los huerfanos por defecto

const SC = "TT19i7wFc6cAgEKrEi4t5V3kHr8JHTT5fq";// direccion del contrato

const USDT = "TExwHCjZYbb7ToQUfQY5JgumwbcXAgeaVd";// USDT contract or token trc20

export default {proxy, PRU, WS,  SC, USDT};
